import { isSuccess } from '@devexperts/remote-data-ts'

import capitalize from 'lodash/capitalize'
import { useEffect, useRef } from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import { useCartTracking } from '@/hooks/useCartTracking'
import { cartSlice } from '@/store/cartSlice/index.ts'
import { licenseSlice } from '@/store/licenseSlice'
import { isLogged } from '@/utils/isLogged.ts'
import {
  CHOOSE_PRODUCT_PATH,
  INSERT_DATA_PATH,
  INSERT_INSURANCE_PATH,
  INSERT_PERIOD_PATH,
  MAP_PATH,
  PAY_PATH,
  SECTOR_PATH,
  THANK_YOU_PATH,
  TICKETS_PATH,
} from '../../app/router/paths'
import { useAppSelector } from '../../hooks/store'
import { appSlice } from '../../store/appSlice'

export const DataLayer = () => {
  const mode = useAppSelector(appSlice.selectors.mode)
  const license = useAppSelector(licenseSlice.selectors.license)
  const location = useLocation()
  useCartTracking()

  useEffect(() => {
    window.dataLayer.push({ Loggato: isLogged() ? 'Si' : 'No' })
  }, [location.pathname])

  useEffect(() => {
    if (!license) return
    window.dataLayer.push({
      Città: license.beach.city,
      'Codice Licenza': license.license,
      'Nome Spiaggia': license.beach.name,
      Regione: license.beach.region,
    })
  }, [license, location.pathname])

  useEffect(() => {
    window.dataLayer.push({ Dominio: capitalize(mode) })
  }, [mode, location.pathname])

  const cartDetail = useAppSelector(cartSlice.selectors.cartDetail)
  const isCartDetailSuccess = isSuccess(cartDetail)
  const paymentLink = isCartDetailSuccess ? cartDetail.value.paymentLink : null
  const hasTrackedRef = useRef<Record<string, boolean>>({})
  useEffect(() => {
    if (!license) return

    // Please note: this ref prevents double tracking for the same path
    const path = location.pathname
    if (hasTrackedRef.current[path]) return

    let tracked = false
    if (matchPath(INSERT_PERIOD_PATH, location.pathname)) {
      window.dataLayer.push({
        'Trackpage view': `/stabilimenti-balneari/${license.license}/prenotazione/selezione-date`,
      })
    } else if (matchPath(CHOOSE_PRODUCT_PATH, location.pathname)) {
      window.dataLayer.push({
        'Trackpage view': `/stabilimenti-balneari/${license.license}/prenotazione/selezione-prodotto`,
      })
    } else if (
      matchPath(MAP_PATH, location.pathname) ||
      matchPath(SECTOR_PATH, location.pathname)
    ) {
      window.dataLayer.push({
        'Trackpage view': `/stabilimenti-balneari/${license.license}/prenotazione/selezione-postazione`,
      })
    } else if (matchPath(TICKETS_PATH, location.pathname)) {
      window.dataLayer.push({
        'Trackpage view': `/stabilimenti-balneari/${license.license}/prenotazione/tickets`,
      })
    } else if (matchPath(INSERT_INSURANCE_PATH, location.pathname)) {
      window.dataLayer.push({
        'Trackpage view': `/stabilimenti-balneari/${license.license}/prenotazione/selezione-assicurazione`,
      })
    } else if (matchPath(INSERT_DATA_PATH, location.pathname)) {
      window.dataLayer.push({
        'Trackpage view': `/stabilimenti-balneari/${license.license}/prenotazione/inserimento-anagrafica`,
      })
    } else if (matchPath(PAY_PATH, location.pathname) && !paymentLink) {
      window.dataLayer.push({
        'Trackpage view': `/stabilimenti-balneari/${license.license}/prenotazione/pagamento-postazione`,
      })
      tracked = true
    } else if (matchPath(PAY_PATH, location.pathname) && paymentLink) {
      window.dataLayer.push({
        'Trackpage view': `/stabilimenti-balneari/${license.license}/prenotazione/link-pagamento-postazione`,
      })
      tracked = true
    } else if (matchPath(THANK_YOU_PATH, location.pathname)) {
      window.dataLayer.push({
        'Trackpage view': `/stabilimenti-balneari/${license.license}/prenotazione/TY-conferma-postazione`,
      })
      tracked = true
    }
    if (tracked) {
      hasTrackedRef.current[path] = true
    }
  }, [location.pathname, license, paymentLink])

  return null
}
